/**
 * Viewport helpers for mobile vs desktop shell.
 *
 * Product UI is mobile-first. Tablets (all current iPads including 12.9"
 * landscape at 1366 CSS px) must use the Mobile experience, not the Desktop
 * marketing iframe page.
 */

/** Max CSS width treated as phone/tablet (Mobile shell). */
export const MOBILE_MAX_WIDTH = 1366;

/**
 * True when the app should render the Mobile shell (phones + tablets).
 * Also treats iPadOS Safari that reports as Macintosh.
 */
export function isMobileViewport() {
  if (typeof window === "undefined") {
    return true;
  }

  if (window.innerWidth <= MOBILE_MAX_WIDTH) {
    return true;
  }

  const ua = navigator.userAgent || "";
  const isIpadOsDesktopUa =
    /Macintosh/.test(ua) && typeof navigator.maxTouchPoints === "number" && navigator.maxTouchPoints > 1;

  return isIpadOsDesktopUa;
}

/** True when the Desktop marketing / wide shell should render. */
export function isDesktopViewport() {
  return !isMobileViewport();
}
